import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (window.location.hostname === "canfeedback.canarabank.in") {
    const newUrl = window.location.href.replace(
      "canfeedback.canarabank.in",
      "canfeedback.canarabank.bank.in"
    );
  
    // Use replace() so there's no "back" history entry
    window.location.replace(newUrl);
  }
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
